<div fxLayout="column" class="layout-padd" fxLayoutGap="20px" fxLayoutAlign="center center" [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill>

    <div fxLayout="column" fxLayoutGap="20px" class="layout-padd bordered-card" fxLayoutAlign="center center">

        <div fxLayoutAlign="center center" class="text-center">
            <span class="mat-subheading">{{'alertmaxWeightComponent.maxWeight' | translate}} </span>
        </div>

        <div fxLayoutAlign="center center" class="dark rad-bord" style="position: relative; height: 60px; width: 80px;">

            <div>
                <span class="mat-headline">{{max_weight}}kg</span>
            </div>
            
            <i class="material-icons whited-ico icon-info clicked" style="position: absolute; top: 3px; right: 5px;" angulartics2On="click" angularticsAction="openWeightTableDial" angularticsCategory="order" matTooltip="{{'basket.rate-weight-prices' | translate}}" (click)="openWeightTableDial()">info</i>

        </div>

    </div>

    <button mat-stroked-button class="full-w dark-ico" (click)="closeDial()" angulartics2On="click" angularticsAction="closeMaxWeightDial" angularticsCategory="order">
        <span class="mat-title">{{"dialogs.go-back" | translate}}</span>
      </button>

</div>